"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function namedArg(type, options) {
    return {
        type,
        description: options && options.description,
        shortName: options && options.shortName,
        excludeFromSchema: !!options.excludeFromSchema,
    };
}
exports.namedArg = namedArg;
function positionalArg(name, type, options) {
    return {
        name,
        type,
        description: options && options.description,
    };
}
exports.positionalArg = positionalArg;
//# sourceMappingURL=cmd-builder.js.map